// extracted by mini-css-extract-plugin
export default {"accordion_wrapper":"zu","accordion_header":"Au","accordion_title":"Bu","accordion_collapse_button":"Cu","accordion_body":"Eu","accordion_wrapper_opened":"Fu","accordion_v2":"Gu"};
    if(module.hot) {
      // 1715188229821
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  